import { Notification, NotificationActionType, NotificationPreferences } from '@domain'

export const basketAnalyzedNotification: Notification = {
	id: 1,
	type: 'MARKET_BASKET_ANALYZED',
	title: 'Market Basket is ready!',
	description: null,
	actions: [
		{
			type: NotificationActionType.LINK,
			label: '1290571 - Mos Eisley Cantina (CA)',
			url: 'https://example.com/app/market-baskets/1',
		},
	],
	read: false,
	readAt: null,
	createdAt: new Date().toISOString(),
}

export const readNotification: Notification = {
	...basketAnalyzedNotification,
	id: 2,
	read: true,
	readAt: new Date().toISOString(),
	createdAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
}

export const basketFailedNotification: Notification = {
	id: 4,
	type: 'BASKET_ANALYSIS_FAILED',
	title: 'Market Basket has an issue :(',
	description: null,
	actions: [
		{
			type: NotificationActionType.LINK,
			label: '1291130 - Tosche Station (CA)',
			url: 'https://example.com/app/market-baskets/4',
		},
	],
	read: false,
	readAt: null,
	createdAt: new Date().toISOString(),
}

const hoursAgo = (hours: number) => new Date(Date.now() - hours * 60 * 60 * 1000).toISOString()

export const mockNotifications: Notification[] = [
	basketAnalyzedNotification,
	{
		...basketAnalyzedNotification,
		id: 3,
		actions: [
			{
				type: NotificationActionType.LINK,
				label: '1291129 - Anchorhead Station (CA)',
				url: 'https://example.com/app/market-baskets/3',
			},
		],
		createdAt: hoursAgo(1),
	},
	readNotification,
	basketFailedNotification,
]

export const mockNotificationPreferences: NotificationPreferences = {
	MARKET_BASKET_ANALYZED: {
		APP: true,
		TEAMS: true,
		EMAIL: false,
	},
	BASKET_ANALYSIS_FAILED: {
		APP: true,
		TEAMS: false,
		EMAIL: true,
	},
}
